import { useTranslation } from 'react-i18next';
import Breadcrumbs from '@app/components/breadcrumbs/Breadcrumbs';
import { BREADCRUMB_IDS } from '@app/configs/breadcrumbs';
import { ROUTES } from '@app/configs/routes';
import SolvencyDeclaration from '@modules/borrower/components/solvencyDeclaration/SolvencyDeclaration';
const SolvencyDeclarationPage = ({ isMobile }) => {
    const { t } = useTranslation();
    const breadcrumbsItems = [
        {
            id: BREADCRUMB_IDS.SOLVENCY_DECLARATION,
            label: t('financing.breadcrumbs.solvency_declaration'),
            path: ROUTES.solvencyDeclaration,
        },
    ];
    return (<div className={isMobile ? 'flex-col leading-5' : 'px-4 pb-4 md:px-6 md-pb-6 flex-col leading-5'}>
            {!isMobile && (<div className="pb-4 leading-5 font-medium">
                    <Breadcrumbs items={breadcrumbsItems} activeBreadcrumb={BREADCRUMB_IDS.SOLVENCY_DECLARATION} type="borrower"/>
                </div>)}
            <SolvencyDeclaration isMobile={isMobile}/>
        </div>);
};
export default SolvencyDeclarationPage;
